const Header = () => {
    return (
        <header>
            <h1>Where Should I Live?</h1>
        </header>
    )
}

export default Header;